import React from "react";
import FlexStack from "../Common/flex-stack";
import {List, ListItemButton, ListItemText} from "@mui/material";
import {useNav} from "../Common/hooks/use-nav";
import RouteService from "../../services/route-service";
import {useRegistriesOfMember} from "./hooks/use-registries";
import {Widget} from "../Common";

export const RegistryListPage = () => {
    const {data: registries} = useRegistriesOfMember();
    const nav = useNav();

    const onSearchResultClick
        = (registryId: string) => nav.push(RouteService.REGISTRY_ANIMAL_LIST, {registryId});

    return (
        <FlexStack>
            <Widget displayName="Register wählen">
                <List>
                    {registries.map(registry =>
                        <ListItemButton  key={registry.id} onClick={() => onSearchResultClick(registry.id)}>
                            <ListItemText primary={registry.name}/>
                        </ListItemButton>
                    )}
                </List>
            </Widget>
        </FlexStack>
    );
};